import { render, staticRenderFns } from "./buy-policy-tips.vue?vue&type=template&id=a7d1cdc4&scoped=true&"
import script from "./buy-policy-tips.vue?vue&type=script&lang=js&"
export * from "./buy-policy-tips.vue?vue&type=script&lang=js&"
import style0 from "./buy-policy-tips.vue?vue&type=style&index=0&id=a7d1cdc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7d1cdc4",
  null
  
)

export default component.exports